import { Text } from '@mantine/core';
import styled, { keyframes } from 'styled-components';

const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(5px); }
  100% { transform: translateY(0px); }
`;

export const Wrapper = styled.div`
  flex: 1;

  .SectionTitle-wrapper {
    padding: 0;
  }

  --grid: rgba(255, 255, 255, 0.05);
  background-size: 20px 20px;
  background-image: linear-gradient(var(--grid) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid) 1px, transparent 1px);
`;

export const BirthdayBanner = styled(Text)`
  background: linear-gradient(90deg, #ff6a00, #ee0979);
  color: white;
  padding: 10px;
  text-align: center;
  font-weight: bold;
  border-radius: 8px;
  margin-bottom: 12px;
  box-shadow: 0 4px 10px #ff6a00;
  animation: ${floatAnimation} 2s infinite ease-in-out;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
